import {
  AccountSchema,
  AvailableBedsSchema,
  FibuConfigurationSchema,
  IAccount,
  IAvailableBeds,
  IFibuConfiguration,
  InstitutionState,
  IShift,
  IVacationEntitlement,
  ShiftSchema,
  VacationEntitlementSchema,
  values,
} from '@dokucoach/common-types';
import * as yup from 'yup';

export const NursingHomeConfigurationSchema = yup.object({
  name: yup.string().required(),
  additional: yup.string().notRequired().nullable().default(undefined),
  additionalAsCompanyName: yup.boolean().nullable().default(false),
  ikNumber: yup.string().notRequired().nullable().default(undefined),
  taxNumber: yup.string().notRequired().nullable().default(undefined),
  street: yup.string().notRequired().nullable().default(undefined),
  houseNumber: yup.string().notRequired().nullable().default(undefined),
  zipCode: yup.string().notRequired().nullable().default(undefined),
  city: yup.string().notRequired().nullable().default(undefined),
  state: yup.mixed<InstitutionState>().oneOf(values(InstitutionState)).required(),
  phone: yup.string().notRequired().nullable().default(undefined),
  fax: yup.string().notRequired().nullable().default(undefined),
  email: yup.string().notRequired().nullable().default(undefined),
  ccEmail: yup.string().notRequired().nullable().default(undefined),
  website: yup.string().notRequired().nullable().default(undefined),
  billingContactPerson: yup.string().notRequired().nullable().default(undefined),
  billingContactPersonPhone: yup.string().notRequired().nullable().default(undefined),
  billingContactPersonEmail: yup.string().notRequired().nullable().default(undefined),
  vacationEntitlements: yup
    .array<IVacationEntitlement>(VacationEntitlementSchema)
    .notRequired()
    .nullable()
    .default(undefined),
  shifts: ShiftSchema.notRequired().nullable().default(undefined),
  availableBeds: yup
    .array<IAvailableBeds>(AvailableBedsSchema)
    .notRequired()
    .nullable()
    .default(undefined),
  accounts: yup.array<IAccount>(AccountSchema).notRequired().nullable().default(undefined),
  fibuConfiguration: FibuConfigurationSchema.notRequired().nullable().default(undefined),
  cashAccount: AccountSchema.notRequired().nullable().default(undefined),
});

export interface INursingHomeConfiguration {
  name?: string;
  additional?: string;
  additionalAsCompanyName?: boolean;
  ikNumber?: string;
  taxNumber?: string;
  street?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  state?: InstitutionState;
  phone?: string;
  fax?: string;
  email?: string;
  ccEmail?: string;
  website?: string;
  billingContactPerson?: string;
  billingContactPersonPhone?: string;
  billingContactPersonEmail?: string;
  vacationEntitlements?: IVacationEntitlement[];
  shifts?: IShift;
  fibuConfiguration?: IFibuConfiguration;
  availableBeds?: IAvailableBeds[];
  accounts?: IAccount[];
  cashAccount?: IAccount;
}
